import { NormalTextInputField } from "@/components";

const HomeFAQsSectionFormField = ({
  isFetching,
  stateDetails,
  handleTextInputChange,
}) => {
  return (
    <>
      {/* Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="home-section-9-faqs-heading"
        fieldName="home-section-9-faqs-heading"
        placeholderText="Heading"
        inputValue={stateDetails?.["home-section-9-faqs-heading"] || ""}
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
      />

      {/* Sub Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        isTextArea={true}
        labelText="Sub Heading"
        fieldId="home-section-9-faqs-sub-heading"
        fieldName="home-section-9-faqs-sub-heading"
        placeholderText="Sub Heading"
        inputValue={stateDetails?.["home-section-9-faqs-sub-heading"] || ""}
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mt-5"
        translateField={true}
      />
    </>
  );
};

export default HomeFAQsSectionFormField;
